import { render, staticRenderFns } from "./UserComments.vue?vue&type=template&id=37efa016&scoped=true"
import script from "./UserComments.vue?vue&type=script&lang=js"
export * from "./UserComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37efa016",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QTimeline from 'quasar/src/components/timeline/QTimeline.js';
import QTimelineEntry from 'quasar/src/components/timeline/QTimelineEntry.js';
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QBanner,QBtn,QChip,QBadge,QExpansionItem,QSelect,QScrollArea,QSpace,QTimeline,QTimelineEntry,QPopupEdit,QInput,QDialog});qInstall(component, 'directives', {ClosePopup});
